/* unplugin-vue-components disabled */import { render } from "./new.vue?vue&type=template&id=7e46eac1&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"

import "./new.vue?vue&type=style&index=0&id=7e46eac1&lang=less&scoped=true"

import exportComponent from "/Users/yfy/work/work/cms-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e46eac1"]])

export default __exports__